
export default {
  data() {
    return {
      itemsPerPage: 15,
      footerProps: {
        'items-per-page-options': [5, 10, 15, 20, -1]
      },
			filters: {
        registrationFilter (value, search, item) {
          if(!search) {
            return true;
          }

					return search != null &&
						typeof value === 'string' &&
						(
              ( item.lastname && item.lastname.toLowerCase().indexOf(search.toLowerCase()) !== -1 )||
              ( item.firstname && item.firstname.toLowerCase().indexOf(search.toLowerCase()) !== -1 )||
              ( item.middlename && item.middlename.toLowerCase().indexOf(search.toLowerCase()) !== -1 )||
              ( item.extname && item.extname.toLowerCase().indexOf(search.toLowerCase()) !== -1 ) ||
              ( item.mobile && item.mobile.toLowerCase().indexOf(search.toLowerCase()) !== -1 ) ||
              ( item.email && item.email.toLowerCase().indexOf(search.toLowerCase()) !== -1 )
            )
				},
			}
    };
  },
  methods: {
    addHeader(headers, text, value) {
      headers.push( { text, value} );
      return headers;
    },
    removeHeader(headers, value) {
      for(let i=0; i<headers.length; i++) {
        if(headers[i].value == value) {
          headers.splice(i, 1);
          i--;
        }
      }
      return headers;
    }
  }
}